import { motion } from "framer-motion";
import usePrefersReducedMotion from "../hooks/usePrefersReducedMotion";

interface JumpingFishProps {
  className?: string;
  size?: number;
  delay?: number;
  duration?: number;
  flip?: boolean;
  color?: string;
}

/**
 * A fish silhouette that leaps in an arc, as if breaching the surface.
 * Self-gates on reduced motion — same gap and same fix as Bubbles.tsx, this
 * ran its infinite repeat animation on every page except Home.tsx's hero
 * (the only call site that happened to wrap it in a reduced-motion check).
 */
export default function JumpingFish({
  className = "",
  size = 48,
  delay = 0,
  duration = 2.6,
  flip = false,
  color = "var(--color-teal-300)",
}: JumpingFishProps) {
  const reducedMotion = usePrefersReducedMotion();
  if (reducedMotion) return null;

  return (
    <motion.div
      className={`pointer-events-none absolute ${className}`}
      style={{ scaleX: flip ? -1 : 1 }}
      initial={{ x: 0, y: 0, opacity: 0, rotate: 0 }}
      animate={{
        x: [0, 30, 60],
        y: [0, -70, 0],
        opacity: [0, 1, 1, 0],
        rotate: [-8, 12, 35],
      }}
      transition={{
        duration,
        delay,
        repeat: Infinity,
        repeatDelay: 3.2,
        ease: [0.33, 0.0, 0.2, 1],
        times: [0, 0.5, 1],
      }}
    >
      <svg width={size} height={size * 0.6} viewBox="0 0 64 40" fill="none">
        <path
          d="M2 20C10 6 26 2 40 6C36 12 36 28 40 34C26 38 10 34 2 20Z"
          fill={color}
        />
        <path d="M40 6C50 8 58 14 62 20C58 26 50 32 40 34C44 26 44 14 40 6Z" fill={color} />
        <circle cx="14" cy="17" r="1.6" fill="var(--color-ocean-950)" />
      </svg>
    </motion.div>
  );
}
